<roma-modal-template
  [title]="'updateCompanyData.title' | translate"
  [showDefaultButtons]="false"
  (cancel)="close()"
  size="md"
  [footerTemplate]="footerButtons"
>
  <div class="client-form">
    <form [formGroup]="form">
      <div class="form-group">
        <label class="form-text" for="name">
          {{ 'updateCompanyData.companyName' | translate }}
        </label>
        <input
          type="text"
          class="general-form-control md form-control"
          id="name"
          aria-describedby="company_name"
          formControlName="company_name"
          (input)="changeName($event)"
          [placeholder]="'updateCompanyData.placeholderCompanyName' | translate"
          [ngClass]="{
            'is-invalid':
              form.controls.name?.invalid && form.controls.name?.touched
          }"
        />
        <roma-field-error-display
          #fieldName
          fieldName="name"
          [errorMsg]="'general.required'"
          [form]="form"
        >
        </roma-field-error-display>
      </div>
      <div class="form-group">
        <label class="form-text" for="nif">
          {{ 'finals.create.nif' | translate }} ({{
            'updateCompanyData.optional' | translate
          }})
        </label>
        <input
          type="text"
          class="general-form-control md form-control"
          id="nif"
          aria-describedby="fiscalName"
          formControlName="fiscalName"
          [placeholder]="'finals.create.nifPh' | translate"
        />
      </div>
      <div class="form-group">
        <label class="form-text" for="address">
          {{ 'finals.create.address' | translate }} ({{
            'updateCompanyData.optional' | translate
          }})
        </label>
        <input
          type="text"
          id="address"
          class="general-form-control md form-control"
          aria-describedby="address"
          [placeholder]="'finals.create.addressPh' | translate"
          [value]="form.get('address')?.value"
          matInput
          romaGooglePlaces
          name="address"
          formControlName="address"
          (placeSelected)="autocompleteSelected($event)"
        />
      </div>
      <div class="dual-column">
        <div class="form-group client-form">
          <label class="form-text" for="address">
            {{ 'finals.create.email' | translate }} ({{
              'updateCompanyData.optional' | translate
            }})
          </label>
          <input
            type="text"
            class="general-form-control md form-control input"
            id="email"
            aria-describedby="email"
            formControlName="email"
            [placeholder]="'finals.create.emailPh' | translate"
            matInput
            [ngClass]="{
              'is-invalid': form.get('email').errors || false
            }"
            name="address"
          />
        </div>
        <div class="form-group client-form">
          <label class="form-text" for="address">
            {{ 'finals.create.phone' | translate }} ({{
              'updateCompanyData.optional' | translate
            }})
          </label>
          <input
            type="text"
            class="general-form-control md form-control input"
            id="phone"
            aria-describedby="phone"
            formControlName="phone"
            [placeholder]="'finals.create.phonePh' | translate"
            matInput
            name="address"
          />
        </div>
      </div>
      <div class="info-banner">
        <img src="/assets/icons/gl_exclamation-circle.svg" />
        <div>
          {{ 'updateCompanyData.info' | translate }}
        </div>
      </div>
    </form>
  </div>
</roma-modal-template>

<ng-template #footerButtons>
  <div class="footer-actions">
    <base-button
      type="submit"
      [disabled]="isLoading || form.invalid"
      [isLoading]="isLoading"
      (mouseenter)="displayTooltip(true)"
      (mouseleave)="displayTooltip(false)"
      (click)="submit()"
    >
      {{ 'forms.save' | translate }}
    </base-button>
    <div class="tooltip-container">
      <div
        *ngIf="showToolTip && form.invalid"
        class="title-tooltip-wrapper"
      ></div>
      <div
        class="help-tooltip"
        *ngIf="showToolTip && form.invalid"
        romaRomaToolTip
        [showToolTip]="showToolTip"
      >
        <div
          [innerHTML]="
            'budgets.settings.create.form.tooltip-invalid' | translate
          "
        ></div>
      </div>
    </div></div
></ng-template>
